import { render, staticRenderFns } from "./LightingSystem.vue?vue&type=template&id=250e028a&scoped=true"
import script from "./LightingSystem.vue?vue&type=script&lang=js"
export * from "./LightingSystem.vue?vue&type=script&lang=js"
import style0 from "./LightingSystem.vue?vue&type=style&index=0&id=250e028a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e028a",
  null
  
)

export default component.exports